module.exports = __webpack_public_path__ + "static/media/idea2.6bd6c777.svg";